import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from '../helpers/axios';
import { useAuth } from 'react-oidc-context';

const UserContext = createContext(undefined);

export const UserProvider = ({ children }) => {
  const { user } = useAuth();
  const [userDetails, setUserDetails] = useState(null);
  const [keycloakId, setKeycloakId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const isLoggedIn = !!userDetails;

  useEffect(() => {
    if (user?.profile?.sub) {
      setKeycloakId(user.profile.sub);
      fetchUserDetails(user.profile.sub);
    }
  }, [user]);

  const fetchUserDetails = async (id) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`/api/user/get/details/?keycloak_id=${id}`);
      setUserDetails(response.data[0]);
    } catch (error) {
      console.error('Failed to fetch user details:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <UserContext.Provider value={{ userDetails, keycloakId, fetchUserDetails, isLoading, isLoggedIn }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
